export type RetryWithBackoffOptions = {
  maxAttempts: number;
  initialDelayMs: number;
  maxDelayMs?: number;
  backoffMultiplier?: number;
  jitterRatio?: number;
  shouldRetry?: (error: unknown, attempt: number) => boolean;
  onRetry?: (error: unknown, attempt: number, delayMs: number) => void;
};

// Delay before the next retry: exponential backoff from initialDelayMs, capped at
// maxDelayMs, with jitter. `attempt` is 1-based (first failure → attempt 1).
export const computeBackoffDelayMs = (
  attempt: number,
  options: RetryWithBackoffOptions
): number => {
  const {
    initialDelayMs,
    maxDelayMs = 10000,
    backoffMultiplier = 2,
    jitterRatio = 0.25,
  } = options;

  const baseDelay = Math.min(
    initialDelayMs * Math.pow(backoffMultiplier, attempt - 1),
    maxDelayMs
  );
  // Spread retries around baseDelay so concurrent failures don't realign on the
  // same backoff tick (thundering herd). Uniform ±jitterRatio, e.g. 0.25 → ±25%.
  const jitter = baseDelay * jitterRatio * (Math.random() * 2 - 1);
  return Math.max(0, baseDelay + jitter);
};
